import config from '../config';

export const ENGAGEMENT_TIER = [
  { key: 1, text: 'Participant', value: 1 },
  { key: 2, text: 'Signatory', value: 2 },
  { key: 3, text: 'No Tier Selected', value: 3 },
  { key: 4, text: 'Not applicable', value: 4 }
];
export const CAMPAIGN_COLOR = '#2178F6';

/**
 * COLORS
 */
export const COLORS = {
  white: '#FFFFFF',
  black: '#000000',
  default: '#2178F6'
};

export const PLAN_TYPE = {
  free: 'free',
  pro: 'pro-monthly',
  premium: 'premium-monthly',
  enterprise: 'enterprise-monthly',
  appsumo: 'appsumo',
  'pro-annually': 'pro-annually',
  'premium-annually': 'premium-annually',
  'enterprise-annually': 'enterprise-annually',
  'amazon-basic-monthly': 'amazon-basic-monthly',
  'amazon-basic-annual': 'amazon-basic-annual',
  'amazon-premium-monthly': 'amazon-premium-monthly',
  'amazon-premium-annual': 'amazon-premium-annual'
};

export const TITLE = [
  'free',
  'pro',
  'enterprise',
  'pro-annually',
  'premium-annually',
  'premium',
  'enterprise-annually',
  'enterprise-monthly',
  'appsumo',
  'amazon-basic-monthly',
  'amazon-basic-annual',
  'amazon-premium-monthly',
  'amazon-premium-annual'
];

export const CAMPAIGN_TYPE = {
  PERSONALIZED: {
    value: 0,
    key: 'personalizedCampaign',
    text: 'Profile Message - Use a profile picture and logo in your campaign'
  },
  VIDEO: {
    value: 1,
    key: 'videoCampaign',
    text: 'Video Message - Use a video and logo in your campaign'
  },
  IMAGE: {
    value: 2,
    key: 'imageCampaign',
    text: 'Image Message - Use an image and logo in your campaign'
  },
  NEXT_GEN: {
    value: 3,
    key: 'nextGenCampaign',
    text: 'Next-gen - Use highly flexible fields to collect user-generated content'
  }
};

export const CAMPAIGN_TYPE_VALUE = {
  0: 'PERSONALIZED',
  1: 'VIDEO',
  2: 'IMAGE',
  3: 'NEXT_GEN'
};

export const VIDEO_SUBMISSION_TYPE = Object.freeze({
  RECORDING: 'recording',
  FILE_UPLOAD: 'file upload'
});

export const ACCEPT_TYPES = {
  VIDEO: 'video/mp4,video/x-m4v,video/mpeg2,video/3gpp,video/x-flv,video/*',
  IMAGE: 'image/*'
};

export const ELEMENT_ICONS = {
  // design elements
  RICH_TEXT_DESIGN_ELEMENT: 'font',
  VIDEO_DESIGN_ELEMENT: 'video-camera',
  IMAGE_DESIGN_ELEMENT: 'image',
  // input elements
  GENERIC_TEXT_AREA_INPUT: 'font',
  GENERIC_MEDIA_INPUT: 'video-camera',
  GENERIC_CHECKBOX_INPUT: 'check-square',
  GENERIC_FILE_INPUT: 'paperclip'
};

export const ELEMENT_ICONS_V2 = {
  // design elements
  RICH_TEXT_DESIGN_ELEMENT: 'Type',
  VIDEO_DESIGN_ELEMENT: 'Video',
  IMAGE_DESIGN_ELEMENT: 'Image',
  // input elements
  GENERIC_TEXT_INPUT: 'Minus',
  GENERIC_TEXT_AREA_INPUT: 'Menu',
  GENERIC_MEDIA_INPUT: 'Video',
  GENERIC_CHECKBOX_INPUT: 'Square',
  GENERIC_FILE_INPUT: 'Image',
  FIRST_NAME_INPUT: 'Type',
  LAST_NAME_INPUT: 'Type',
  EMAIL_INPUT: 'Mail',
  PHONE_INPUT: 'Phone',
  ADDRESS_INPUT: 'MapPin'
};

export const ACCOUNT_PLAN_MAP = {
  free: {
    planId: 'free',
    label: 'Free'
  },
  appsumo: {
    planId: 'appsumo',
    label: 'AppSumo'
  },
  pro: {
    label: 'Pro Monthly',
    frequency: 'monthly',
    amount: config?.stripe?.plans?.pro?.amount,
    planId: config?.stripe?.plans?.pro?.planId
  },
  premium: {
    label: 'Premium Monthly',
    frequency: 'monthly',
    amount: config?.stripe?.plans?.premium?.amount,
    planId: config?.stripe?.plans?.premium?.planId
  },
  enterprise: {
    label: 'Enterprise Monthly',
    frequency: 'monthly',
    amount: config?.stripe?.plans?.enterprise?.amount,
    planId: config?.stripe?.plans?.enterprise?.planId
  },
  'enterprise-monthly': {
    label: 'Enterprise Monthly',
    frequency: 'monthly',
    amount: config?.stripe?.plans?.enterpriseMonthly?.amount,
    planId: config?.stripe?.plans?.enterpriseMonthly?.planId
  },
  'enterprise-annually': {
    label: 'Enterprise Annually',
    frequency: 'annually',
    amount: config?.stripe?.plans?.enterpriseAnnually?.amount,
    planId: config?.stripe?.plans?.enterpriseAnnually?.planId
  },
  'pro-annually': {
    label: 'Pro Annually',
    frequency: 'annually',
    amount: config?.stripe?.plans?.proAnnually?.amount,
    planId: config?.stripe?.plans?.proAnnually?.planId
  },
  'premium-annually': {
    label: 'Premium Annually',
    frequency: 'annually',
    amount: config?.stripe?.plans?.premiumAnnually?.amount,
    planId: config?.stripe?.plans?.premiumAnnually?.planId
  },
  'amazon-basic-monthly': {
    label: 'Amazon Basic Monthly',
    frequency: 'monthly',
    amount: config?.stripe?.plans?.amazonBasicMonthly?.amount,
    planId: config?.stripe?.plans?.amazonBasicMonthly?.planId
  },
  'amazon-basic-annual': {
    label: 'Amazon Basic Annual',
    frequency: 'annually',
    amount: config?.stripe?.plans?.amazonBasicAnnual?.amount,
    planId: config?.stripe?.plans?.amazonBasicAnnual?.planId
  },
  'amazon-premium-monthly': {
    label: 'Amazon Premium Monthly',
    frequency: 'monthly',
    amount: config?.stripe?.plans?.amazonPremiumMonthly?.amount,
    planId: config?.stripe?.plans?.amazonPremiumMonthly?.planId
  },
  'amazon-premium-annual': {
    label: 'Amazon Premium Annual',
    frequency: 'annually',
    amount: config?.stripe?.plans?.amazonPremiumAnnual?.amount,
    planId: config?.stripe?.plans?.amazonPremiumAnnual?.planId
  }
};



// WEBPACK FOOTER //
// ./src/constants/index.js